module.exports = __webpack_public_path__ + "static/media/background_5.b82e9bcc.mp3";